import { lazy } from 'react';

import Loadable from '../components/Loadable';
import { ROUTES } from '../utils/constant';
import MinimalLayout from 'layout/MinimalLayout';

const Login = Loadable(lazy(() => import('pages/login')));


const PublicRoutes = {
    path: ROUTES.ROOT,
    element: <MinimalLayout />,
    children: [
        {
            path: ROUTES.ROOT,
            element: <Login />
        },
    ]
};

export default PublicRoutes;
